module.exports = __webpack_public_path__ + "static/media/startIconProjects.98e68073.svg";